import React from 'react';
import { useObserverReturningStore } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { BetterDropButton } from '../../ui/DropButton';
import { useResolve } from '../Container';
import { BoardUsageModel } from '../account/BoardUsageModel';
import { Page } from '../common/Page';
import { HideIfHasPermission } from '../common/PermissionElements';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { BoardInfo } from './BoardInfo';
import { EditorSession } from './EditorSession';

export const AnonymousHeaderBlock: LFC = () => {
    const board = useResolve(EditorSession).get(BoardInfo);
    const limit = useObserverReturningStore(useResolve(BoardUsageModel));
    if (!limit.isBoardActive(board.id)) return null;
    return <HideIfHasPermission any={['bo:write']}>
        <Page.HeaderBlock>
            <Flexer flex="row" padding="0 .5 0 0">
                <a href={`/${board.id}/join`}>
                    <BetterDropButton variant="primary" padding=".5">
                        <span style={{ fontWeight: 450 }}>Join Board</span>
                    </BetterDropButton>
                </a>
            </Flexer>
        </Page.HeaderBlock>
    </HideIfHasPermission>;
};
